<template>
  <div class="fraction-data">
    <table>
      <tr>
        <th>{{ this.$t('reporting.industry.materialType') }}</th>
        <th>{{ this.$t('reporting.industry.emptied') }}</th>
        <th>{{ this.$t('reporting.industry.emptyingCount') }}</th>
        <th>{{ this.$t('reporting.industry.costsPerKG') }}</th>
        <th>{{ this.$t('reporting.industry.totalFractionCosts') }}</th>
      </tr>
      <tr v-for="fraction in fractions" :key="fraction.fraction_id">
        <td>{{ fraction.localized_fraction_name }}</td>
        <td>{{ decimal(fraction.total_fraction_weight_kg) }} kg</td>
        <td>{{ fraction.emptying_count }}</td>
        <td>{{ euro(fraction.fraction_costs_per_kg) }}/kg</td>
        <td>{{ euro(fraction.total_fraction_costs) }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import stringUtils from '@/components/mixins/stringUtils'

export default {
  name: 'FractionDataTable',
  props: {
    fractions: { required: true, type: [Array] },
  },
  mixins: [stringUtils],
}
</script>

<style lang="scss" scoped>
.fraction-data {
  padding: 20px 0;

  table {
    font-size: 12px;
    max-width: 400px;
    text-align: center;
    border-collapse: collapse;

    tr {
      border-bottom: 1px solid #cdc9c9;
    }

    tr:last-child {
      border-bottom: none;
    }

    th {
      padding: 5px 15px;
      font-weight: 400;
    }

    td {
      padding: 5px 10px;
    }
  }
}
</style>
